// extracted by mini-css-extract-plugin
module.exports = {"centerPosition":"SetPasswordStyle_centerPosition__3GRRW"};